const t={"%(count)d Student":"%(count)d Students","%(count)d Teacher":"%(count)d Teachers","%(count)d Student Not Imported":"%(count)d Students Not Imported","Video matches your search!":"Videos match your search!"};export{t as default};
//# sourceMappingURL=nebulaI18nPluralTerms.js.map
